import React from 'react';
import { Dayjs } from 'dayjs';
import cx from 'classnames';
import 'dayjs/locale/ru';
import {
    LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { DateRange } from '@mui/x-date-pickers-pro/models';
import css from './DatePicker.module.scss';
import { deleteTooltipMuiX } from './utils';
import CloseIcon from '@mui/icons-material/Close';

type TDatePicker = {
  value: DateRange<Dayjs>;
  setDateRange: (value: DateRange<Dayjs>) => void;
}

export const DatePicker = ({ value, setDateRange }: TDatePicker) => {
  return (
    <div className={css.root}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
        <DateRangePicker
          dayOfWeekFormatter={(weekday) => `${weekday.format('dd')}`}
          format='DD/MM/YYYY'
          localeText={{ 
            start: 'Period from',
            end: 'Period to',
          }}
          slotProps={{
            fieldSeparator: { sx: { display: "none" } },
            textField: { placeholder: '', sx: { fontSize: '12px !impotant', fontWeight: 'bold !impotant' } },
            popper: {
              sx: {
                ".MuiPaper-root": { border: "1px solid rgba(146, 155, 244, 1)", borderRadius: "10px", boxShadow: 'none' },
                '.MuiPickersSlideTransition-root': { minWidth: '210px', minHeight: '200px' },
                '.MuiDateRangeCalendar-monthContainer': { borderRight: 'none !important' },
                '.MuiPickersDay-root': { width: '22px', height: '22px', fontSize: '8px' },
                '.MuiDayCalendar-weekDayLabel': { width: '22px', height: '9px', color: 'rgba(203, 203, 204, 1)' },
                '.MuiPickersArrowSwitcher-button': { padding: 0, background: 'none' },
              },
            },
          }}
          className={css.dataPicker}
          value={value}
          onOpen={deleteTooltipMuiX}
          onAccept={value => setDateRange(value)}
        />
      </LocalizationProvider>
      {(value[0]) && <CloseIcon className={css.icon} sx={{ fontSize: '16px' }} onClick={() => setDateRange([null, value[1]])} />}
      {(value[1]) && <CloseIcon className={cx(css.icon, css.clearTo)} sx={{ fontSize: '16px' }} onClick={() => setDateRange([value[0], null])} />}
    </div> 
  );
}